import apiClient from "../apiClient";
import ENDPOINTS from "../endpoints";


import generalClient from "../generalClient";

export const getPincodeDetails = async (pincode) => {
  const response = await generalClient.get(
    `https://api.postalpincode.in/pincode/${pincode}`
  );
  return response.data;
};